<template>

    <div>
        <v-flex
                row wrap align-top justify-center>
            <List :elements="intents"
                  :titleHeader="header"
                  :addNewTitle="addNewIntentTitle"
                  :createCallback="navigate"
                  :clickCallback="navigate"
                  :deleteCallback="openDeleteIntentDialog"></List>
        </v-flex>

        <v-dialog
                v-model="deleteIntentDialog"
                max-width="650"
        >
            <v-card>
                <v-card-title class="headline">Deleting {{ selectedIntent.nameToShow}} </v-card-title>
                <v-card-text>
                    Are you sure?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="closeDeleteIntentDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="red"
                            flat="flat"
                            @click="deleteIntent()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>


</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import List from "@/components/Lists/List";
    import {mapGetters, mapState,} from "vuex";

    export default {
        name: "IntentList",
        components: {List},
        //props: ["type"],
        data() {
            return {
                newIntent: {
                    id: 0,
                    //idIntent: intent.idIntent,
                    create: true,
                    intentName: "NewIntent",
                    questions: [{
                        name: "",
                        text: null,
                        type: "EXAMPLE",
                        utterance: ""
                    }],
                    answers: [""],
                },
                header: this.$t("training.conversation.intent"),
                addNewIntentTitle: this.$t('training.conversation.createIntent.name'),
                intents: [],
                selectedIntent: {},
                deleteIntentDialog: false,
            }
        },
        computed: {
        ...mapGetters("UserState", {
                userSettings: "getSettings",
            }),
        },
        created() {

            this.getIntents();
        },
        methods: {
            navigate(intent) {
                let path = {
                    name: "IntentTraining",
                    params: {
                        create: intent.create,
                        id: intent.idIntent,
                        intentName: intent.name,
                    },
                };
                RouterService.goTo(path);
            },
            openDeleteIntentDialog(intent) {
                this.selectedIntent = intent;
                this.deleteIntentDialog = true;
            },
            closeDeleteIntentDialog() {
                this.selectedIntent = {};
                this.deleteIntentDialog = false;
            },
            deleteIntentPlugin(){
                let requestUrl = {
                    url: UrlsService.linkIntentPlugin,
                    timeout: TimeService.secondsToMillis(0),
                };

                let requestData = {
                    interactionData: {
                        text: "DELETE",
                        linkIntentPluginInteractionRequest: {
                            intentName: this.selectedIntent.nameToShow,
                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Delete plugin of the intent",
                    loading: "Waiting for delete the plugin...",
                    error: "Cannot delete the plugin of the intent...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                    });
            },
            deleteIntent(){
                this.deleteIntentDialog = false;
                let requestUrl = {
                    url: UrlsService.doIntentOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "DELETE",
                        language: this.userSettings.chatbot.language.current.locale,
                        dialogicInteractionRequest: {
                            name: this.selectedIntent.idIntent,
                            displayName: this.selectedIntent.nameToShow
                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Delete Intent",
                    loading: "Waiting for deleting the intent...",
                    error: "Cannot delete the intent...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.deleteIntentPlugin();
                        this.getIntents();

                    });
            },
            getIntents() {
                let requestUrl = {
                    url: UrlsService.doIntentOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "LIST",
                        language: this.userSettings.chatbot.language.current.locale,
                        dialogicInteractionRequest: {

                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Intents",
                    loading: "Waiting for list of intents...",
                    error: "Cannot get intents...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.intents = [];
                        let response = responseSuccess;
                        for (let i = 0; i < response.response.intents.length; i++) {
                            let questions = [];
                            let answers = [];
                            if(response.response.intents[i].trainingPhrases !== null) {
                                for (let k = 0; k < response.response.intents[i].trainingPhrases.length; k++) {
                                    questions.push(response.response.intents[i].trainingPhrases[k]);
                                }
                            }
                            if(response.response.intents[i].messages !== null) {
                                for (let j = 0; j < response.response.intents[i].messages.length; j++) {
                                    answers.push(response.response.intents[i].messages[j]);
                                }
                            }
                            this.intents.push({
                                id: i + 1,
                                idIntent: response.response.intents[i].name,
                                nameToShow: response.response.intents[i].displayName,
                                questions: questions,
                                answers: answers,
                                create: false,
                            });
                            if (i !== response.response.intents.length - 1) {
                                this.intents.push({divider: true, inset: false,});
                            }
                        }
                    });
            },
        }
    }
</script>

<style scoped>

</style>